import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subscription} from 'rxjs';
import {StoreService} from '../../../../services/store.service';
import {AuthService} from '../../../../services/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {AppSettings} from '../../../../config/AppSettings';
import {ScbMembersPointsCoins} from '../../../../forms/scb-members-points-coins';

@Component({
  selector: 'app-members-points-details',
  templateUrl: './members-points-details.component.html',
  styleUrls: ['./members-points-details.component.css']
})
export class MembersPointsDetailsComponent implements OnInit, OnDestroy, AfterViewInit {


  @ViewChild('select_caption_tpl', {static: true}) set select_caption_tpl(value: ElementRef) {
    this._select_caption_tpl = value;
    // this.setColumns();
    this.cdr.markForCheck();
  }

  public storeExtObj: {};
  public editAllowed = false;

  private subs: Array<Subscription> = [];

  public loading_text = '';
  public is_loading = false;
  public rows: any[];
  public require_filter = {index: 0, filter: []};

  private _select_caption_tpl: ElementRef;

  public column_definition: any[];
  public is_admin: boolean;
  public user_id = 0;

  public ScbMembersPointsCoins: ScbMembersPointsCoins;

  constructor(private storeService: StoreService,
              private authService: AuthService,
              private router: Router,
              private route: ActivatedRoute,
              private cdr: ChangeDetectorRef,
              public dialog: MatDialog) {
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    this.is_admin = this.authService.isAdmin();
    this.editAllowed = this.authService.isAdmin() || this.authService.hasRole(AppSettings.ifa_guild_id, AppSettings.group_page_admin)
        || this.authService.hasRole(AppSettings.ifa_guild_id, AppSettings.group_event_admin);
    this.subs.push(this.route.params.subscribe((params: any) => {
      this.user_id = params.user_id;

      this.require_filter.filter = [];
      this.require_filter.filter.push('filter[user_id][0][mode]=equals');
      this.require_filter.filter.push('filter[user_id][0][operator]=and');
      this.require_filter.filter.push('filter[user_id][0][value]=' + String(this.user_id));
      this.require_filter.index = 1;


      this.storeExtObj = {user_id: params.user_id};
      this.ScbMembersPointsCoins = new ScbMembersPointsCoins(this.storeService, this.authService, 'edit');
      this.cdr.detectChanges();
    }));
  }

  public addRow() {
    if (this.editAllowed) {
      this.router.navigateByUrl('/members-points/' + this.user_id + '/add');
    }
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }


  public rowSelected($event: any) {
    const route = 'bot/events/' + $event.row.event_id;
    if ($event.in_new_tab) {
      const url = this.router.createUrlTree([route]);
      const serializedUrl = this.router.serializeUrl(url);

      // Insert `#` between the domain and route
      const modifiedUrl = '#/' + serializedUrl;
      window.open(modifiedUrl, '_blank');
    } else {
      this.router.navigateByUrl(route);
    }
  }
}
